export const vitalsConstant = {
	VALUES_ENCODE_BELOW_AVERAGE_ONE: -0.06229710,
	VALUES_ENCODE_BELOW_AVERAGE_TWO: -0.15714600,
	VALUES_ENCODE_BELOW_AVERAGE_THREE: -0.11581100,
	// Average
	VALUES_ENCODE_AVERAGE_ONE: -0.13445400,
	VALUES_ENCODE_AVERAGE_TWO: -0.28683000,
	VALUES_ENCODE_AVERAGE_THREE: -0.21901900,

	// Judgment of spatial relations
	// Below Average
	VALUES_SPATIAL_BELOW_AVERAGE_ONE: 0.07488000,
	// Average
	VALUES_SPATIAL_AVERAGE_ONE: 0.00000000,

	// Decisions under time pressure
	// Below Average
	VALUES_DECISIONS_BELOW_AVERAGE_ONE: 0.16163800,
	// Average
	VALUES_DECISIONS_AVERAGE_ONE: 0.04732060,

	// Guided Movement Control
	// Below Average
	VALUES_MOVEMENT_BELOW_AVERAGE_ONE: 0.09833910,
	// Average
	VALUES_MOVEMENT_AVERAGE_ONE: -0.04265600,

	// Ability to quickly respond to complex information
	// Below Average
	VALUES_INFORMATION_BELOW_AVERAGE_ONE: 0.32940200,
	// Average
	VALUES_INFORMATION_AVERAGE_ONE: -0.14876200,

	// Initialization and reactions
	// Below Average
	VALUES_REACTIONS_BELOW_AVERAGE_ONE: 0.02035570,
	VALUES_REACTIONS_BELOW_AVERAGE_TWO: 0.01557210,
	// Average
	VALUES_REACTIONS_AVERAGE_ONE: -0.09919030,
	VALUES_REACTIONS_AVERAGE_TWO: 0.27587500,

	// Fine motor control
	// Below Average
	VALUES_MOTOR_BELOW_AVERAGE_ONE: 0.12999000,
	// Average
	VALUES_MOTOR_AVERAGE_ONE: 0.00000000,

	// Track and process visual events
	// Below Average
	VALUES_VISUAL_BELOW_AVERAGE_ONE: 0.00000000,
	VALUES_VISUAL_BELOW_AVERAGE_TWO: -0.42210000,
	VALUES_VISUAL_BELOW_AVERAGE_THREE: 0.33894000,
	// Average
	VALUES_VISUAL_AVERAGE_ONE: -0.73813600,

	// Impulse control
	// Below Average
	VALUES_IMPULSE_BELOW_AVERAGE_ONE: -0.30115300,
	// Average
	VALUES_IMPULSE_AVERAGE_ONE: -0.65172500,

	// Vitals Cutpoints
	VITALS_CUTPOINT_PASS: 25,
	VITALS_CUTPOINT_FAIL: 50,
};